// extracted by mini-css-extract-plugin
module.exports = {"root":"BackgroundImage--root--2RdWX","image":"BackgroundImage--image--22SW8"};